<template>
  <div id="app">
    <router-view v-if="isRouterAlive"/>
  </div>
</template>

<script>
import { setZoom, pconlineFn, isPC } from "@/assets/util";
export default {
  name: 'App',
  provide() {
    return {
      reload: this.reload
    }
  },
  data() {
    return {
      isRouterAlive: true
    }
  },
  created() {
    //在页面加载时读取sessionStorage里的状态信息
    if (sessionStorage.getItem("store")) {
      this.$store.replaceState(Object.assign({}, this.$store.state, JSON.parse(sessionStorage.getItem("store"))));
      window.localStorage.removeItem("store");
    }
    if (window.localStorage.getItem("paramInfo")) {
      let paramInfo = JSON.parse(window.localStorage.getItem("paramInfo"));
      this.$store.state.salesManagement = paramInfo.salesManagement ? true : false;
      this.$store.state.retailManagement = paramInfo.retailManagement ? true : false;

      // 设置页面缩放比例
      window.onload = window.onresize = function() {
        let pageZoom = paramInfo.pageZoom;
        if (Number(pageZoom) > 0) setZoom(pageZoom);
      }
    }
    //在页面刷新时将vuex里的信息保存到sessionStorage里
    window.addEventListener("beforeunload", () => {
      sessionStorage.setItem("store", JSON.stringify(this.$store.state));
    });

    // 判断是否有登录过
    let path = this.$route.path;
    if (!this.$store.state.isLogin && path == '/home') {
      this.$router.push({path: '/login'});
    }
  },
  mounted() {
    if (isPC() && localStorage.getItem('versionType') != 35) {
      const { ipcRenderer } = window.require('electron');
      // 监听主进程的关闭指令
      ipcRenderer.on('window-close-notify', (data) => {
        this.cleanup(this, 1);
      });
    }
  },
  methods: {
    cleanup () {
      if (this.$store.state.isLogin) {
        pconlineFn(this, 1);
      }
    },
    reload() {
      this.isRouterAlive = false;
      this.$nextTick(() => {
        this.isRouterAlive = true;
        this.$forceUpdate();
      })
      window.location.href = this.addUrlParam('t', new Date().getTime());
      setTimeout(() => {
        window.location.reload(true);
      }, 500)
    },
    addUrlParam(key, value) {
      let href = window.location.href.split('#');
      var curUrl = href[0];
      var re = new RegExp("([?&])" + key + "=.*?(&|$)", "i");
      var separator = curUrl.indexOf('?') !== -1 ? "&" : "?";
      curUrl = curUrl.match(re)? curUrl.replace(re, '$1' + key + "=" + value + '$2') : (curUrl + separator + key + "=" + value);
      return href[1]? curUrl + '#' + href[1] : curUrl;
    }
  }
}
</script>

<style>
#app {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
}
body {
  margin: 0;
  font-size: 14px;
  line-height: 1;
  font-family: "Microsoft YaHei";
}

h1, h2, h3, h4, h5, h6 {
  margin: 0;
  font-weight: normal;
  font-size: 14px;
}

p, dl, dd {
  margin: 0;
}

ul, ol {
  margin: 0;
  padding: 0;
  list-style: none;
}

a {
  text-decoration: none;
  color: #333;
  cursor: pointer;
}

i, em {
  font-style: normal;
}

strong, b {
  font-weight: normal;
}

img {
  border: none;
  vertical-align: bottom;
}

table {
  border-spacing: 0;
  border-collapse: collapse;
}

th, td {
  padding: 0;
  text-align: left;
  vertical-align: top;
}

input {
  border: none;
  background: none;
  outline: none;
}

textarea {
  resize: none;
}

button {
  margin: 0;
  padding: 0;
  border: 1px solid transparent;
  outline: none;
}

.clearFix {
  zoom: 1;
}

/*ie7以下兼容*/
.clearFix:after {
  content: "";
  display: block;
  clear: both;
  font-size: 0;
  line-height: 0;
}

/* 去掉箭头 */
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
}

input[type="number"] {
  -moz-appearance: textfield;
}

/* 去除radio报错 */
input[aria-hidden=true]{
  display: none !important;
}

/* 改变滚动条样式 */
::-webkit-scrollbar {
  width: 10px;
  height: 10px;
}

/* 滑块 */
::-webkit-scrollbar-thumb {
  border-radius: 5px;
  background-color: rgba(168, 168, 168, .5);
}

/* 轨道部分 */
::-webkit-scrollbar-track {
  box-shadow: inset 0 0 5px rgba(0, 0, 0, .1);
  background-color: rgba(237, 237, 237, .5);
  border-radius: 5px;
}

.el-message {
  /*top: 50% !important;*/
  min-width: 300px;
  max-width: 90%;
}

.el-dialog__header {
  background-color: #F8F8F8;
}

.window_wrap {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, .4);
  z-index: 100;
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: center;
}

.img_wrap {
  position: fixed;
  top: 50px;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, .5);
}

.img_wrap .el-dialog__body {
  padding: 0 !important;
}

.el-message {
  padding: 10px 20px 10px 15px !important;
  top: 50% !important;
  min-width: 100px !important;
  max-width: 90% !important;
  background: rgba(0, 0, 0, .7) !important;
  color: #fff !important;
  border-color: rgba(0, 0, 0, .7) !important;
  border-radius: 100px !important;
}

.el-message__content {
  font-size: 12px !important;
}

/*.el-message-box {
	width: 80% !important;
	min-width: 260px !important;
	max-width: 400px !important;
}*/

.el-table--scrollable-x .el-table__body-wrapper {
  z-index: 1;
}

.el-table .el-button--small, .el-table .el-button--small.is-round {
  padding: 0 !important;
}

.el-table td, .el-table th {
  padding: 4px 0 !important;
}
</style>



// WEBPACK FOOTER //
// src/App.vue